module.exports = __webpack_public_path__ + "img/CardImage9.4feee775.png";